export const VIEW_SCREEN_EVENT_WITH_PREV_DATA =
  "VIEW_SCREEN_EVENT_WITH_PREV_DATA";

export const VIEW_CATEGORY = "View Category";

export const VIEW_GROUP_BUY_ORDER_DETAILS = "View Group Buy Order Details";

export const HIDE_GROUP_BUY_ORDER_MODAL = "Hide Group Buy Order Success Modal";

export const SHARE_GROUP_BUY = "Share Group Buy";

export const VIEW_NOT_ONBOARDED_MODAL = "View Not Onboarded Modal";

export const HIDE_NOT_ONBOARDED_MODAL = "Hide Not Onboarded Modal";

export const VIEW_ONBOARDING_IMAGE = "Phone Number Screen Image";

export const HIDE_ORDER_CANCEL_REASON_MODAL = "Hide Cancellation Reason Modal";

export const CONFIRM_ORDER_CANCEL = "Confirm Order Cancel Action";

export const VIEW_ORDER_CANCEL_SUCCESS_MODAL =
  "View Order Cancel Success Modal";

export const HIDE_ORDER_CANCEL_SUCCESS_MODAL =
  "Hide Order Cancel Success Modal";

export const HIDE_PLACE_ORDER_SUCCESS_MODAL = "Hide Place Order Success Modal";

export const SHARE_REFER_LINK = "Share Refer Link";

export const HIDE_REMOVE_ITEMS_FROM_CART_MODAL =
  "Hide Remove Items From Cart Modal";

export const REMOVE_ITEMS_AND_PLACE_ORDER = "Remove Items and Place Order";

export const CLICK_SUPPORT = "Click Support Button";

export const HIDE_SUPPORT_MODAL = "Hide Support Modal";

export const VIEW_BANNERS = "View Banners";

export const VIEW_CATEGORY_PRODUCTS = "View Category Products";

export const VIEW_REQUESTED_PRODUCTS = "View Requested Products";

export const ONESIGNAL_NOTIFICATION = "OneSignal Notification Clicked";

export const EDIT_BANK_DETAILS = "AddBankDetails edit new bank";

export const ADD_BANK_DETAILS = "AddBankDetails add new bank";

export const ADD_CUSTOMER = "Add Customer";

export const EDIT_CUSTOMER = "Edit Customer";

export const SELECT_CUSTOMER_FROM_CONTACTS = "Select From Contacts";

export const SEND_NUMBER_FOR_OTP = "Phone Number Submit";

export const SUBMIT_OTP = "Submit OTP";

export const RESEND_OTP = "Resend OTP";

export const SUBMIT_NAME = "Submit Name";

export const CHOOSE_FROM_AVATAR = "Choose from Avatar";

export const SHOW_AVATAR_MODAL = "Show Avatar Modal";

export const HIDE_AVATAR_MODAL = "Hide Avatar Modal";

export const TAKE_PHOTO = "Take Photo";

export const CHOOSE_FROM_GALLERY = "Choose From Gallery";

export const NEW_LEADER_SIGNUP = "New Leader Signup";

export const NEW_TEAM_LEADER_ADDRESS = "Submit Address";

export const CHANGE_ADDRESS = "Change Address";

export const ADD_ADDRESS = "Add Address";

export const ADD_GROUP_BUY_PRODUCT = "Add group buy product";

export const REMOVE_GROUP_BUY_PRODUCT = "Remove group buy product";

export const CONFIRM_GROUP_BUY_ORDER = "Click Confirm Group Buy Order";

export const GROUP_BUY_ORDER_SUCCESS = "Group Buy Order Success";

export const SEARCH_GROUP_BUY_CUSTOMERS = "Search group buy customers";

export const RESET_GROUP_BUY_SEARCH = "Reset Group Buy Customers Search";

export const CLICK_GROUP_BUY_DETAILS = "Click group buy details";

export const SHARE_GROUP_BUY_OFFER = "Share Group Buy Offer";

export const CLICK_GROUP_BUY_OFFER = "Click Group Buy Offer";

export const VIEW_COMPLETED_GROUP_BUY = "View Completed Group Buy";

export const VIEW_VIDEO = "View Video";

export const VIEW_ORDER_DETAILS = "View Order Details";

export const VIEW_CANCELLATION_REASON_MODAL = "View Cancellation Reason Modal";

export const CLICK_CANCEL_ORDER_ACTION = "Click Cancel Order Action";

export const SELECT_CANCELLATION_REASON = "Select Cancellation Reason";

export const CANCEL_ORDER_SUCCESS = "Cancel Order Success";

export const USER_PERMISSIONS = "User Permissions";

export const PLACE_ORDER_MODAL_SUCCESS = "View Place Order Success Modal";

export const REMOVE_ITEMS_FROM_CART_MODAL = "Remove Items From Cart Modal";

export const PLACE_ORDER_SUCCESS = "Place Order Success";

export const OPT_WHATSAPP_UPDATES = "Opt WhatsApp Updates";

export const ADD_TO_CART = "Add to Cart - Order Flow";

export const REMOVE_FROM_CART = "Remove from Cart - Order Flow";

export const REQUEST_PRODUCT = "Request a Product";

export const SEARCH_PRODUCT = "Search Product";

export const VIEW_SEARCH_RESULTS = "View Search Results";

export const EXIT_CREATING_TICKET = "Exit Creating Ticket";

export const EXIT_WITHOUT_CREATING_TICKET = "Exit Without Creating Ticket";

export const SUPPORT_LINK_ACTION = "Support Link Action";

export const TOGGLE_TNC_MODAL = "Toggle TnC Modal";

export const VIEW_TRANSACTION_SCREEN = "View Transaction Screen";

export const VIEW_PASSBOOK = "View Passbook";

export const FILTER_APPLIED = "Filter Applied";

export const VIEW_WITHDRAW_MONEY_SCREEN = "View Withdraw Money Screen";

export const WRONG_UPI = "WithdrawMoney wrong upi";

export const WITHDRAW_INVALID_MONEY = "WithdrawMoney invalid amount";

export const CREATE_UPI = "WithdrawMoney create Upi";

export const WITHDRAW_MONEY = "WithdrawMoney withdraw money";

export const BANK_CLICK = "WithdrawMoney bank click";

export const JOIN_NEW_BANK = "WithdrawMoney join new bank";

export const WITHDRAW_MONEY_MODAL_CLOSE = "WithdrawMoney modal close";

export const ADD_FIRST_CUSTOMER = "Add First Customer";

export const VIEW_CUSTOMER = "View Customer";

export const DEEPLINKS_PARAMS = "HANDLE_DEEP_LINK_PARAMS";

export const SKIP_VIDEO = "Skip";

export const DENIED_PERMISSIONS = "";

export const DENIED_PERMISSION_MODAL_CLICKED =
  "Permissions Denied Modal Cicked";

export const VIEW_OFFER_MODAL = "View Offer Modal";

export const CLICK_OFFER_CTA = "Click Offer CTA";

export const VIEW_SEARCH = "View Search";

export const SHARE_LEADER_SHOP = "Share Leader Shop";

export const SHARE_PRODUCT_ON_WA = "Share product on WA";

export const CLICK_SUPPORT_CALL_BUTTON = "Click Support Call Button";

export const CLICK_OPEN_SUPPORT_SCREEN = "Click Open Support Screen";

export const SHARE_ORDER_ON_WA = "Share Order on WA";

export const CLICK_PROFILE_LINK = "Click Profile Link";

export const VIEW_ORDER_ITEMS = "View Order Items";

export const VIEW_CART = "View Cart";

export const PLACE_ORDER_ACTION = "Place Order Action";

export const OPEN_PROFILE_SIDE_MENU = "Open Profile Side Menu";

export const CLICK_APP_SHARE_CARD = "Click App Share Card";

export const CLICK_REFER_LINK = "Click Refer Link";

export const CLOSE_PROFILE_SIDE_MENU = "Close Profile Side Menu";

export const PROFILE_SIDE_DRAWER_PROFILE = "View Profile - Profile Side Menu";

export const PROFILE_SIDE_DRAWER_LOGOUT = "Click Logout - Profile Side Menu";

export const CLICK_SUPPORT_LINK = "Click Support Link";

export const TICKET_RAISED_CLICK = "Ticket raised click";

export const VIEW_MASTER_ORDER_LIST = "View Master Order List";

export const VIEW_MASTER_CUSTOMER_LIST = "View Master Customer List";

export const CONTACT_CUSTOMER_ON_WA = "Contact Customer on WA";

export const START_ORDER_FOR_CUSTOMER = "Start Order for Customer";

// Screens
export const LOGIN_SCREEN = "Phone Number";

export const OTP_VERIFY_SCREEN = "Enter OTP";

export const HOME_SCREEN = "Home Screen";

export const ONBOARDING_VIDEO_SCREEN = "Onboarding Video";

export const PERMISSONS_SCREEN = "Permissions Screen";

export const GULLAK_SCREEN = "Gullak";

export const PROFILE_DRAWER_CLICKED = "Profile Drawer Submenu Clicked";

export const LEADER_NAME_SCREEN = "Leader Name";

export const USER_ADDRESS_SCREEN = "User Address";

export const NOT_SERVICEABLE_SCREEN = "Not Serviceable";

export const USER_PERMISSIONS_MODAL_SCREEN = "User Permission Modal";

export const USER_PERMISSIONS_DENIED_SCREEN = "User Denied Permissions";

// HomePage

export const BANNER_CLICKED = "Banner clicked";

export const LEADER_CARD_SHARED = "Leader card shared";
// export const LEADER_CARD_CONTACTED = "Leader card contacted";

export const BANNER_CAROUSEL_SCROLLED = "Banner carousel scrolled";

export const SKU_SHARED = "SKU List shared";

export const BANNER_SHARED = "CMS Banner shared";

export const CMS_SKULIST_SEE_ALL = "CMS SKU List see all Clicked";

export const PRODUCT_DETAILS_CLICKED = "Product details clicked";

export const CMS_CATEGORY_CLICKED = "CMS Category Clicked";

// Refferal Page
export const CL_REFER_LANDING = "CL Refer Landing";
export const CL_REFER_REFER_NOW = "CL Refer Refer Now";

// gullak

export const ACCOUNT_ADDED = "Account added";
export const ACCOUNT_DELETED = "Account deleted";
export const ACCOUNT_EDITED = "Account edited";

export const IN_APP_RATING_SHOWN = "In-App Rating Shown";

export const IN_APP_RATING_ERROR = "In-App Rating Error";
// RVP Events
export const RVP_EVENTS = {
  RETURN_CANCELLED: "Return Cancelled",
};

// TodaysCustomerEvents
export const CX_PAGE_NAME_CLICKED = "Cx Page Name Clicked";
export const CX_SEARCH_BAR_CLICKED = "Customer Search Bar Clicked";
export const CX_SEARCHED = "Customer Searched";

// Deactivation screen
export const DEACTIVATION_SCREEN_VIEWED = "deactivation screen viewed";

// Main bottom tab bar
export const BOTTOM_TAB_CLICKED = "Bottom Tab Clicked";
